import type { AttributeDictionaryType } from './types';

// Dictionary types that feed master_products columns (state/origin) rather
// than EAV attribute rows. Mirrors COLUMN_TYPE_KEYS in user-mngt-srv.
export const COLUMN_TYPE_KEYS: readonly string[] = ['state', 'origin'];

export const dictionaryValues = (types: AttributeDictionaryType[] | undefined, key: string): string[] =>
  types?.find((t) => t.key === key)?.values.map((v) => v.value) ?? [];

// Label lookup for buildCanonicalOptions — falls back to the raw value for legacy entries.
export const dictionaryLabelFor = (
  types: AttributeDictionaryType[] | undefined,
  key: string
): ((value: string) => string) => {
  const byValue = new Map(types?.find((t) => t.key === key)?.values.map((v) => [v.value, v.label]) ?? []);
  return (value: string) => byValue.get(value) ?? value;
};

export const eavTypes = (types: AttributeDictionaryType[] | undefined): AttributeDictionaryType[] =>
  types?.filter((t) => !COLUMN_TYPE_KEYS.includes(t.key)) ?? [];
